import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-book-credit-note-report-in-detail-officer',
  templateUrl: './book-credit-note-report-in-detail-officer.component.html',
  styleUrls: ['./book-credit-note-report-in-detail-officer.component.scss']
})
export class BookCreditNoteReportInDetailOfficerComponent implements OnInit {

  // ==================== Variables ====================
 startDate: string = '';
  endDate: string = '';
  reportType: string = '';
  officerepwise: string = '';
  repName: string = '';
  currentDate = new Date();

  filterData: any[] = [];
  groupedData: any[] = [];
  grandTotal: number = 0;
  booksellerwise: any;

  constructor(
    private dialogRef: MatDialogRef<BookCreditNoteReportInDetailOfficerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    this.startDate = this.data?.startDate || '';
    this.endDate = this.data?.endDate || '';
    this.officerepwise = this.data?.office_rep_name || this.data?.officerepwise || '';
     this.booksellerwise = this.data?.booksellerwise || this.data?.booksellerwise || '';
    this.repName = this.data?.rep_name || this.data?.repName || '';
    this.reportType = this.data?.reportType || 'InDetail-Officer';

    this.getCreditNoteData();
  }

  getCreditNoteData(): void {
    const req = {
      start_crdtnote_date: this.startDate,
      end_crdtnote_date: this.endDate,
      office_rep_name: this.officerepwise,
      rep_name: this.repName,
      bill_no: this.data?.bill_no || '',
      book_seller_name: this.booksellerwise,
      crdtnote_no: this.data?.crdtnote_no || '',
      book: this.data?.book || ''
    };

    this.service.getBookCreditNoteReport(req).subscribe({
      next: (res: any) => {
        this.filterData = res || [];
        this.groupDataByOfficeRepAndRep();
      },
      error: (err) => {
        console.error('Error fetching Book Credit Note data:', err);
      }
    });
  }

  groupDataByOfficeRepAndRep(): void {
    const officeRepGroups: { [key: string]: any } = {};

    // First level: Group by office_rep_name
    this.filterData.forEach((item) => {
      const officeRep = item.office_rep_name || 'Unknown';

      if (!officeRepGroups[officeRep]) {
        officeRepGroups[officeRep] = {
          office_rep_name: officeRep,
          representatives: {},
          totalAmount: 0
        };
      }

      // Second level: Within each office rep, group by rep_name
      const repName = item.rep_name || 'Unknown';

      if (!officeRepGroups[officeRep].representatives[repName]) {
        officeRepGroups[officeRep].representatives[repName] = {
          rep_name: repName,
          totalAmount: 0
        };
      }

      // Sum the credit note amount
      const amount = parseFloat(item.crdtnote_total) || 0;
      officeRepGroups[officeRep].representatives[repName].totalAmount += amount;
      officeRepGroups[officeRep].totalAmount += amount;
    });

    // Convert to array format for template
    this.groupedData = Object.values(officeRepGroups).map((officeGroup: any) => {
      return {
        office_rep_name: officeGroup.office_rep_name,
        records: Object.values(officeGroup.representatives),
        totalAmount: officeGroup.totalAmount
      };
    });

    // Sort office reps alphabetically
    this.groupedData.sort((a: any, b: any) => 
      a.office_rep_name.localeCompare(b.office_rep_name)
    );

    // Sort representatives within each office rep
    this.groupedData.forEach((group: any) => {
      group.records.sort((a: any, b: any) => 
        a.rep_name.localeCompare(b.rep_name)
      );
    });

    // Calculate grand total
    this.grandTotal = this.groupedData.reduce(
      (acc, grp: any) => acc + grp.totalAmount, 
      0
    );
  }

printPage4(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=1200,height=900');

  WindowPrt.document.write(`
    <html>
    <head>
      <title>Book Credit Note Report</title>

      <style>
        /* ================= PAGE ================= */
        @page {
          size: A4 portrait;
          margin: 10mm;
        }

        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        body {
          margin: 0;
          font-family: Arial, sans-serif;
          font-size: 12px;
          color: #000;
          line-height: 0.5;
        }

        /* ================= WRAPPER ================= */
        .print-wrapper {
          padding: 0;
        }

        /* ================= TABLE ================= */
        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          font-size: 14px;

          /* FORCE SOLID BLACK RIGHT EDGE */
          border-right: 1px solid #000 !important;
        }

        th, td {
          border: 1px solid #000 !important;
          padding: 1px 3px;
          vertical-align: middle;
          line-height: 0.5;
        }

        /* FORCE SOLID BLACK RIGHT BORDER */
        tr td:last-child,
        tr th:last-child {
          border-right: 1px solid #000 !important;
        }

        /* FORCE SOLID BLACK LEFT BORDER */
        tr td:first-child,
        tr th:first-child {
          border-left: 1px solid #000 !important;
        }

        /* ================= HEADER ================= */
        thead th {
          white-space: normal !important;
          background: #f1f1f1 !important;
          font-weight: bold;
          text-align: center;
          padding: 2px 4px;
        }

        /* ================= BODY ================= */
        tbody td {
          white-space: nowrap !important;
        }

        /* DATE CELLS */
        .date-cell {
          white-space: normal !important;
          word-break: break-word !important;
          text-align: center;
        }

        /* OFFICE HEADER ROW */
        .office-header-row {
          font-weight: bold;
          text-align: center;
        }

        /* SUBTOTAL ROW */
        .subtotal-row {
          background-color: #f4b084 !important;
          font-weight: bold;
        }

        /* GRAND TOTAL ROW */
        .grand-total-row {
          background-color: #c8753f !important;
          font-weight: bold;
          color: #fff !important;
        }

        /* REPEAT HEADER / FOOTER */
        thead { display: table-header-group !important; }
        tfoot { display: table-footer-group !important; }

        /* AVOID PAGE BREAK INSIDE ROWS */
        tr, td, th {
          page-break-inside: avoid !important;
        }

        /* ================= PRINT ONLY ================= */
        @media print {
          .noPrint {
            display: none !important;
          }
        }
      </style>
    </head>

    <body>
      <div class="print-wrapper">
        ${printContent.innerHTML}
      </div>
    </body>
    </html>
  `);

  WindowPrt.document.close();
  WindowPrt.focus();

  setTimeout(() => {
    WindowPrt.print();
    WindowPrt.close();
  }, 500);
}


printPageA(): void {
  const printContent = document.getElementById('print-section');
  const WindowPrt = window.open('', '', 'width=1200,height=900');

  WindowPrt.document.write(`
    <html>
      <head>
        <title>Book Credit Note Report</title>
        <style>

          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          @page {
            size: A4 portrait;
            margin-left: 20mm;

          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 9px;
             line-height: 1;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid black !important;
            padding: 6px 8px;
            white-space: nowrap !important;
             line-height: 1;
          }
               tr td:last-child,
        tr th:last-child {
          border-right: 1px solid #000 !important;
        }

          thead th {
           
          }

          thead {
            display: table-header-group !important;
          }

          tfoot {
            display: table-row-group !important;
            background: #ff9966 !important;
            font-weight: bold;
          }

          tr, td, th {
            page-break-inside: avoid !important;
          }

          /* Prevent text wrapping in all cells */
          .no-wrap {
            white-space: nowrap !important;
          }

          @media print {
            .noPrint { display: none !important; }
            
            th, td {
              white-space: nowrap !important;
            }
          }

        </style>
      </head>

      <body>
        ${printContent?.innerHTML}
      </body>
    </html>
  `);

  WindowPrt.document.close();
  WindowPrt.focus();

  setTimeout(() => {
    WindowPrt.print();
    WindowPrt.close();
  }, 500);
}
printPageA4(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) {
    console.error('Print section not found');
    return;
  }

  const printWindow = window.open('', '', 'width=1200,height=900');

  printWindow!.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>A4 Portrait Report</title>

      <style>
        /* ================= PAGE SETUP ================= */
        @page {
          size: A4 portrait;
          margin: 10mm;
        }

        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          box-sizing: border-box;
        }

        body {
          margin: 0;
                   font-family: Arial, sans-serif;
          font-size: 12px;
          color: #000;
          line-height: 1;
        }

        /* ================= PRINT WRAPPER ================= */
        .print-wrapper {
          width: 100%;
        }

        /* ================= TABLE ================= */
        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          border-right: 2px solid #000 !important;
        }

        th, td {
          border: 1px solid #000 !important;
          padding: 6px;
          vertical-align: middle;
          line-height: 1;
          white-space: normal;
          word-break: break-word;
        }

        tr td:last-child,
        tr th:last-child {
          border-right: 2px solid #000 !important;
        }

        /* ================= HEADER (TEXT COLLAPSE FIX) ================= */
        thead th {
          background: #f1f1f1 !important;
          font-weight: bold;
          text-align: center;
          font-size: 13px;
          padding: 12px 8px;
          line-height: 1.4;
          white-space: normal;       /* 🔥 IMPORTANT */
          word-break: break-word;    /* 🔥 IMPORTANT */
        }

        /* Optional: Main title row */
        .office-header-row {
          font-size: 15px;
          font-weight: bold;
          text-align: center;
          line-height: 1.5;
          white-space: normal;
        }

        .subtotal-row {
          background-color: #f4b084 !important;
          font-weight: bold;
        }

        .grand-total-row {
          background-color: #c8753f !important;
          font-weight: bold;
          color: #fff !important;
        }

        /* ================= PAGE BEHAVIOUR ================= */
        thead { display: table-header-group; }
        tfoot { display: table-footer-group; }

        tr, td, th {
          page-break-inside: avoid;
        }

        /* ================= PRINT ONLY ================= */
        @media print {
          .noPrint {
            display: none !important;
          }
        }
      </style>
    </head>

    <body>
      <div class="print-wrapper">
        ${printContent.innerHTML}
      </div>
    </body>
    </html>
  `);

  printWindow!.document.close();
  printWindow!.focus();

  setTimeout(() => {
    printWindow!.print();
    printWindow!.close();
  }, 500);
}















  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}